<template>
    <div>
        <input type="hidden" name="contact_id" :value="value">
        <el-select
            v-model="value"
            filterable
            clearable
            remote
            placeholder="Search"
            :remote-method="search"
            :loading="loading"
            class="form-control"
            @input="onInput"
            popperClass="custom-popper">
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="format(item)"
                :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
  import {addQueryParams} from "../libs/url";

  export default {
    props: {
      url: String,
      selected: Object
    },

    data() {
      return {
        loading: false,
        value: null,
        options: [],
      };
    },

    methods: {
      search(text) {
        this.loading = true;
        const url = addQueryParams(this.url, {text});
        axios.get(url)
          .then(this.onSuccess)
          .catch(this.onError)
          .finally(() => {
            this.loading = false;
          })
      },

      onSuccess({data}) {
        this.options = _.get(data, 'data');
      },

      onError({response}) {
        this.options = [];
      },

      /**
       * @param {Object} item
       * @return {String}
       */
      getFullName(item) {
        const values = _.values(
          _.pick(item, ['first_name', 'last_name'])
        );

        return _.join(values, ' ');
      },

      /**
       * @param {Object} item
       * @return {string}
       */
      format(item) {
        const phoneNumber = _.get(item, 'phone_number');
        return this.getFullName(item) + (_.isEmpty(phoneNumber) ? '' : ` (${phoneNumber})`);
      },

      /**
       * @param {*} value
       */
      onInput(value) {
        this.$emit('input', value || null);
      },


    },

    mounted() {
      if (this.selected) {
        this.options = [this.selected];
        this.value = this.selected.id;
      }
    },
  }
</script>
